import * as React from 'react'
import * as Dom from 'react-dom'
import * as Router from 'react-router-dom'

import 'virtual:windi.css'
import { MainEdit } from './component/Edit'

import { Footer } from './component/Footer'
import { Header } from './component/Header'
import { Main, MainSingle } from './component/Main'

import 'react-photo-view/dist/react-photo-view.css'

const app = (
  <React.StrictMode>
    <Router.BrowserRouter basename='/chahoutan'>
      <Header />
      <Router.Switch>
        <Router.Route exact path={["/", "/index", "/index.html"]} component={Main} />
        <Router.Route path="/:id([1-9][0-9]*)/edit" component={MainEdit} />
        <Router.Route path="/:id([1-9][0-9]*)" component={MainSingle} />
        <Router.Redirect to="/" />
      </Router.Switch>
      <Footer />
    </Router.BrowserRouter>
  </React.StrictMode>
)

Dom.render(app, document.querySelector('section'))
